import React from 'react';

import AutomationFileConfigEditorTransformsSection from '../AutomationFileConfigEditorTransformsSection';
import {AutomationInputFileConfigEditorProps} from '../AutomationFileConfigUtils';

export default function AutomationInputFileConfigEditorTransformsSection(
  props: AutomationInputFileConfigEditorProps
): JSX.Element {
  return (
    <AutomationFileConfigEditorTransformsSection
      automationFileConfig={props.inputFileConfig}
      allowPreview={false}
      baseSchema={props.baseSchema}
      configFileType="input"
      description="(Optional) Transform your input file after it is generated by Benchling."
      onUpdateConfig={props.onUpdateConfig}
      sectionNumber={4}
      title="Apply transforms to the input file"
    />
  );
}
